import { Message } from 'element-ui';
import { i18n } from '@/locales';

export function copyText(text) {
  const textToCopy = text.trim(); // Get text and remove potential extra whitespace
  if (navigator.clipboard && window.isSecureContext) {
    // Use Clipboard API in secure contexts (HTTPS)
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        Message.success(i18n.t('copied'));
      })
      .catch((err) => {
        console.error('Failed to copy text using Clipboard API:', err);
        Message.error(i18n.t('copy_failed'));
      });
  } else {
    // Fallback for insecure contexts (HTTP) or older browsers
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    // Make the textarea out of viewport
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        Message.success(i18n.t('copied'));
      } else {
        Message.error(i18n.t('copy_failed'));
        console.error('Fallback: Failed to copy text using execCommand');
      }
    } catch (err) {
      console.error('Fallback: Error copying text using execCommand:', err);
      Message.error(i18n.t('copy_failed'));
    }
    document.body.removeChild(textArea);
  }
}
